var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profileaccountscreen"},[_c('div',{staticClass:"page-wrapper"},[_c('ProfileAccountComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }